// extracted by mini-css-extract-plugin
module.exports = {"title":"title__2qVPN","icon":"icon__1wHPD"};